import React from 'react';
import {isWebDesktopView} from '../../../utils';
import LandscapeView from './index.landscape';
import PortraitView from './index.portrait';

const SignInScreen = (props) => {
  var isWebDesktop = isWebDesktopView();
  return isWebDesktop ? (
    // passing props for navigation props
    <LandscapeView {...props} />
  ) : (
    // passing props for navigation props
    <PortraitView {...props} />
  );
};

export default SignInScreen;
